<template lang="pug">
.page.brands(ref="page")
  .inner-gap.container
    pre-approval-buyer-warning

    .all-brands
      .page__shelf
        h1.page__title All brands
        .page__actions
          div
            .mb-1
              help-tag(tooltip="Find brands by state") State (Province/Territory)
            el-select.mr-2(
              :value="filters.state"
              @change="handleFilterChange('state', $event)"
              filterable)
              el-option(v-for="(s, k) in addressStates" :label="s.name" :value="s.id" :key="k")
          div
            .mb-1 Sort by
            el-select(
              :value="filters.sort"
              @change="handleFilterChange('sort', $event)")
              el-option(v-if="isBuyer || isHeadBuyer" label="Order by Popularity" value="relevance_score-desc")
              el-option(v-for="(s, k) in sortByOptions" :label="s.name" :value="s.id" :key="k")

      .page__description.mb-2.paginator
        template(v-if="paginator") Showing&nbsp;
          span.count {{ records.length }}
          | &nbsp;over&nbsp;
          span.total {{ paginator.total }}
          | &nbsp;{{ paginator.total > 1 ? 'brands' : 'brand'  }}
        template(v-else) -

      infinite-fetcher(
        :fetch="fetch"
        :paginator="paginator"
        loading-text="Loading more brands...")
        brands-grid(:records="records" :loading="loading" trackProps="BRANDS_LIST")

      .ender
</template>

<script>
import { pickBy } from 'lodash'
import { mapGetters } from 'vuex'
import InfiniteFetcher from '~/components/InfiniteFetcher'
import BrandsGrid from '~/components/brands/BrandsGrid'
import PreApprovalBuyerWarning from '~/components/PreApprovalBuyerWarning'

export default {
  name: 'Brands',

  key (route) {
    return route.fullPath
  },

  components: {
    InfiniteFetcher,
    BrandsGrid,
    PreApprovalBuyerWarning
  },

  layout: 'catalog',

  data () {
    return {
      records: [],
      loading: false,
      paginator: null,
      filters: {},
      sortByOptions: [
        { id: 'name-asc', name: 'Order by name - A-Z' },
        { id: 'name-desc', name: 'Order by name - Z-A' }
      ]
    }
  },

  fetch () {
    const {
      sort = this.isBuyer || this.isHeadBuyer ? 'relevance_score-desc' : 'name-asc',
      state
    } = this.$route.query

    this.filters = {
      sort,
      state: Number(state) || state
    }

    return this.fetch(this.filters)
  },

  head () {
    return {
      title: 'All brands'
    }
  },

  computed: {
    ...mapGetters({
      addressStates: 'master/addressStates',
      isBuyer: 'authentication/isBuyer',
      isHeadBuyer: 'authentication/isHeadBuyer',
      isPreApprovalBuyer: 'authentication/isPreApprovalBuyer'
    })
  },

  watch: {
    '$route.query' (newQuery, oldQuery) {
      if (this._inactive || JSON.stringify(newQuery) === JSON.stringify(oldQuery))
        return

      const {
        sort = this.isBuyer || this.isHeadBuyer ? 'relevance_score-desc' : 'name-asc',
        state
      } = newQuery

      this.filters = {
        sort,
        state: Number(state) || state
      }

      this.fetch()
    }
  },

  methods: {
    _normalizeQuery (query) {
      const { state, sort: sortBy, term, page, per_page = 44 } = query

      let sort = this.isBuyer || this.isHeadBuyer ? 'relevance_score' : 'name'
      let direction = this.isBuyer || this.isHeadBuyer ? 'desc' : 'asc'

      if (sortBy) [sort, direction] = sortBy.split('-')

      return pickBy({
        'q[address_state_id]': state,
        sort,
        direction,
        term,
        page,
        per_page
      })
    },

    handleFilterChange (key, payload) {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          [key]: payload
        }
      })?.catch(this.$debug.log)
    },

    fetch (query = {}, { clear = true } = {}) {
      if (clear) this.loading = true

      return this.$api.catalog.searchBrands(
          this._normalizeQuery({
            ...this.$route.query,
            ...query
          })
        )
        .then(res => {
          this.paginator = this.$paginators.parse(res)
          this.records = [
            ...(clear ? [] : this.records),
            ...res.results
          ]
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    &.categories {
      margin-top: 32px;
    }
  }
  .page--title {
    margin: 2em 0 0.5em;
  }
  .paginator {
    .count, .total {
      font-weight: $--font-weight-bold;
      color: $--color-primary;
      margin: 0 .35em;
    }
  }
</style>
